import { Idea, MediaType } from '~/content/types';
import { RpcMediaVideo, RpcUpdate, RpcUpdateMedia } from '~/post/types';

const getPostTypeFromIdea = (idea: Idea): string => {
  let type = 'text';
  if (idea.content.media) {
    const mediaLength = idea.content.media.length;
    type = mediaLength > 0 ? 'multipleImage' : 'image';
  }
  return type;
};

const parseIdeaMedia = (
  media: Idea['content']['media'] = []
): RpcUpdateMedia[] => {
  // only one video is allowed in the composer, no extra media here
  const video = media.find((m) => m.type === MediaType.video);
  if (video) {
    return [
      {
        video: {
          id: video.id ?? 'no-id?',
          title: '',
          thumbnails: [video.thumbnailUrl ?? ''],
          details: {} as RpcMediaVideo['details'],
        },
        thumbnail: video.thumbnailUrl ?? '',
        uploaded: 'true',
        progress: '100',
        alt_text: video.alt,
        source: video.url,
      },
    ];
  }

  // if we don't have a video, map throug images and gifs
  return media
    .filter((m) => m.type !== MediaType.video)
    .map((m) => {
      return {
        alt_text: m.alt,
        progress: '100',
        source: '',
        uploaded: 'true',
        thumbnail: m.thumbnailUrl || '',
        photo: m.url,
        picture: m.url,
      };
    });
};

// Parse to accommodate text only ideas for now
export const parseIdeaToComposerPost = (
  idea: Idea,
  user: { id: string; email: string }
): RpcUpdate | Record<string, never> => {
  const [media, ...extra_media] = parseIdeaMedia(idea?.content.media);
  const type = getPostTypeFromIdea(idea);
  return {
    id: '',
    annotations: [],
    commentEnabled: false,
    commentText: '',
    comments: [],
    createdAt: 0,
    day: '',
    dueAt: 0,
    dueTime: '',
    due_at: 0,
    hasPushNotifications: false,
    headerDetails: {},
    imageUrls: [],
    isDraft: false,
    isFixed: false,
    isManager: false,
    isPastDue: false,
    isPastReminder: false,
    isSent: false,
    linkAttachment: {},
    links: [],
    media,
    extra_media,
    needsApproval: false,
    pinned: false,
    postDetails: {
      postAction: '',
      isRetweet: false,
      isCustomScheduled: false,
      isInstagramReminder: false,
      isPendingTiktokPost: false,
    },
    profileId: '',
    profileService: '',
    profileServiceType: '',
    profileTimezone: '',
    profile_service: '',
    retweet: false,
    retweetCommentLinks: [],
    scheduledAt: 0,
    scheduled_at: 0,
    serviceLink: '',
    serviceUpdateId: '',
    shopgridLink: '',
    source_url: '',
    statistics: {},
    subprofile_id: '',
    title: '',
    type,
    updateType: '',
    user: {
      id: user.id,
      avatar: '',
      email: user.email,
    },
    imageSrc: '',
    campaignDetails: undefined,
    text: idea.content.text || '',
    postContent: {
      text: idea.content.text || '',
      type,
    },
    ideaId: idea.id,
    fromIdea: true,
    thread: undefined,
  };
};
